import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { H1, H2, P, Box, Button } from '@veracity/vui';

const NotFound = () => {
  const [countdown, setCountdown] = useState(5);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          navigate('/home');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <Box style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '60vh',
      textAlign: 'center',
      gap: '20px'
    }}>
      <H1 style={{ fontSize: '4rem', margin: '0', color: '#e53e3e' }}>404</H1>
      <H2 style={{ fontSize: '1.5rem', margin: '0', color: '#2d3748' }}>Page Not Found</H2>
      <P style={{ color: '#718096', maxWidth: '400px', lineHeight: '1.5' }}>
        Sorry, the page you're looking for doesn't exist. 
        You'll be redirected to the home page in {countdown} seconds.
      </P>
      <Box style={{ display: 'flex', gap: '15px' }}>
        <Button 
          style={{ padding: '10px 20px' }} 
          onClick={() => navigate('/home')}
        >
          Go to Home
        </Button>
        <Button 
          style={{ padding: '10px 20px' }} 
          variant="outline"
          onClick={() => navigate('/checklists')}
        >
          View Checklists
        </Button>
      </Box>
    </Box>
  );
};

export default NotFound;